import React from 'react';
import ProductPage from '../components/ProductPage';
import { DALCOMM_J1_IMAGES } from '../data/dalcomm';

const DalcommJ1HeadsetPage = ({ onRequestDemo, onRequestQuote }) => {
  const productData = {
    productName: 'J1 Carbon Fiber Pilot’s Headset',
    partNumber: 'DALCOMM-J1-CARBON',
    tagline: 'Leave the Noise Behind, and Enjoy the Flight.',
    description:
      'Dalcomm Technologies’ carbon-fiber pilot’s headset offers superior sound quality, exceptional comfort, and maximum versatility. Engineered to impede noise, the pilot hears only what is critical to the mission. The ultra-lightweight carbon-fiber construction — hand-made from real carbon — provides unsurpassed comfort and durability. The interchangeable cord system means one headset flies fixed-wing in the morning and a helicopter at night. Ordered to your exact mission profile.',
    image: DALCOMM_J1_IMAGES[0],
    images: DALCOMM_J1_IMAGES,
    imageContain: true,
    features: [
      {
        title: 'Real Carbon Fiber, Hand-Made',
        description:
          '10.7 oz (303 g) — genuine carbon-fiber construction. Popular Mechanics calls carbon fiber "the miracle material" — this is what a Lamborghini-grade material feels like on your head.',
      },
      {
        title: 'Four Noise-Blocking Tiers',
        description:
          'Choose Passive (23 dB), Passive + CEP military-grade ear plugs (+29 dB), Passive + Active ANR, or Passive + Active + Bluetooth. Every tier stacks on the same lightweight body.',
      },
      {
        title: '23 dB Passive Attenuation, Certified',
        description:
          'Independent-laboratory-certified 23 dB of mechanical noise blocking from the ear cup itself — before any electronics touch the signal.',
      },
      {
        title: 'CEP Ear Plugs Option (+29 dB)',
        description:
          'Adds military-grade Communications Ear Plugs (CEP USA) inside the ear cup — 29 dB extra attenuation on top of the 23 dB passive. Designed for jet engine testing and helicopter landing pads.',
      },
      {
        title: 'Active Noise Cancelling (ANR)',
        description:
          'Electronic ANR layered on the mechanical block — the outer mic samples ambient noise, inverts the wave, and cancels it inside the cup. Only ATC, intercom, and music remain.',
      },
      {
        title: 'Bluetooth (with ANR variant)',
        description:
          'Wirelessly connect to phone or tablet — hands-free calls, briefings, weather, and music alongside the aircraft audio.',
      },
      {
        title: 'Interchangeable Cord System',
        description:
          'Swap cord to fit any aircraft: fixed-wing twin plugs, helicopter (straight or coiled), 5-pin Airbus XLR, or USB Type-A for sim and video conferencing.',
      },
      {
        title: 'Full-Flex Mic Boom — 270° Rotation',
        description:
          'Boom rotates 270° so the headset can be worn on either side. Noise-cancelling amplified electret microphone.',
      },
      {
        title: '3.5 mm Aux Audio Input',
        description:
          'Plug in a phone, tablet, or audio player. 3.5 mm male-to-male adapter included in the box.',
      },
      {
        title: '65-Month Warranty',
        description:
          'Standard 65-month manufacturer warranty on the headset.',
      },
    ],
    specifications: [
      { label: 'Construction', value: 'Real carbon fiber, hand-made' },
      { label: 'Weight', value: '10.7 oz (303 g)' },
      { label: 'Passive Attenuation', value: '23 dB (independent-laboratory certified)' },
      { label: 'CEP Option', value: '+29 dB attenuation (CEP USA military-grade)' },
      { label: 'Noise-Blocking Tiers', value: 'Passive · Passive + CEP · Passive + Active (ANR) · Passive + Active + Bluetooth' },
      { label: 'Microphone', value: 'Noise-cancelling amplified electret · 270° boom rotation' },
      { label: 'Aux Input', value: '3.5 mm aux audio (adapter included)' },
      { label: 'Connection Options', value: 'Twin plugs (fixed wing) · Helicopter (straight or coiled) · 5-pin Airbus XLR' },
      { label: '10% Off Second Cable', value: 'SBJ-1 / SBJ-2 / SBJ-15 / SBJ-12 (+$70) · SBJ-USB (+$116)' },
      { label: 'Ear Seals', value: 'Foam · Gel · Gel + Foam · Protein Leather' },
      { label: 'Dimensions', value: '12 × 12 × 6 in (packaged)' },
      { label: 'Warranty', value: '65 months manufacturer warranty' },
      { label: 'Price Range', value: '$579 – $1,121 (Passive $579 · CEP $705 · ANR $805 · ANR + BT $1,005)' },
    ],
    applications: [
      'Professional pilot daily use — fixed-wing and helicopter',
      'Jet engine testing and helicopter landing-pad operations (CEP variant)',
      'Long-leg IFR ops where ANR fatigue reduction is critical',
      'Bluetooth calls and briefings while flying',
      'Cross-platform pilots who need one headset for multiple aircraft',
      'Corporate flight departments standardizing on premium equipment',
    ],
  };

  return <ProductPage {...productData} onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />;
};

export default DalcommJ1HeadsetPage;
